import * as React from "react"

export const useDerivedState = <A>(
  init: A,
  derive: (oldState: A) => A,
  deps: ReadonlyArray<any>
): [A, React.Dispatch<React.SetStateAction<A>>] => {
  const [state, setState] = React.useState(init)

  React.useEffect(() => setState(derive), deps)

  return [state, setState]
}
